import { Component, OnDestroy, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router, Event, NavigationEnd } from '@angular/router';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { Observable, Subscription, catchError, filter, interval, mergeMap, of, take, throwError } from 'rxjs';
import { MetaDataService } from './service/metaData.service';
import { NetworkService } from './service/network.service';
import { EligibilityService } from './service/eligibility.service';
import { UserService } from './service/user.service';
import { CONSTANTS } from './constants';
import { environment } from 'src/environments/environment';
import { SetUserNotificationService } from './service/setUserNotification.service';
import { AppServices } from './service/app.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})  export class AppComponent implements OnInit, OnDestroy {
  title = 'Doc_As_A_Code';
  public showDocumentBanner: boolean = false;
  public appLoaded: boolean = true;
  isEligible: any = '';
  public url: any;
  public showTermsDialog: boolean = false;
  public defTitle: string = '';
  public isDocument: any = '';
  public isValidDocument:boolean=false;
  startUrl: string;
  endUrl: string;
  public getMeta:boolean=false;
  public pageNotfound:boolean=false;
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  isOnline: boolean;
  subscriptions: Subscription[] = [];
  public networkStatusSubscription: Subscription;
  public isuserOffline=false;
  public isOff:boolean=false;
  private docsUrl:string='';
  networkStatus: boolean = false;
  onlineStatus: boolean;
  vpnConnected: boolean = true;
  isProductLine:boolean=false;
  isUserEligible:boolean=false;
  public isBannerPage:boolean=true;
  public productLineLoaded:boolean=false;
  public hrefLink: string;
  public docUId: any;
  public sOSessionID: any;
  public noFooter:boolean=false;
  public isfixedFooter:boolean=false;
  public apiError:any='';
  public isapiError:boolean=false;
  public withoutFilter:boolean=true;
  isWildcardRoute: boolean = false;
  isLocalServer=environment.dacSessionId;    private eventSubscriptions: any[] = [];
  private destroyRef = inject(DestroyRef);
  private preventClose = false; // Default to false, will be updated by the service
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private eventBus = inject(AmdocsEventBusService);
  private elService = inject(EligibilityService);
  private metaData = inject(MetaDataService);
  private route = inject(ActivatedRoute);
  private networkService = inject(NetworkService);
  private eligibilityService = inject(EligibilityService);
  private userService = inject(UserService);
  private notificationCheckInterval: any;
  private appServices= inject(AppServices);
  private setUserNotificationService= inject(SetUserNotificationService);

  constructor() {
     this.initializeEventMappings();
     this.initializeEventBus();
     if (window.location.href.indexOf('_callback') > -1 && sessionStorage.getItem(CONSTANTS.SessionSTORAGE.isdocumentCallback)) {
       this.router.navigate(['/document']);
     }
     if (window.location.href.indexOf('_callback') > -1 && sessionStorage.getItem(CONSTANTS.SessionSTORAGE.shareId)) {
       const id = sessionStorage.getItem(CONSTANTS.SessionSTORAGE.shareId);
       const redirectLink = `/searchresults?searchID=${id}`;
       this.router.navigateByUrl(redirectLink);
     }
     this.eventBus.on('online', (data: any) => {
       let elgData = this;
       setTimeout(() => {
         let userData = {
           "SO_Session_ID": sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID) ? sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID) : '',
           "User_ID": elgData.userService.getEmail(),
           "IP_Details": "",
           "Emp_ID": elgData.userService.getEmployeeCode(),
           "DaC_Session_ID": ""
         };
         let statsdata = {
           actionType: CONSTANTS.STATISTICS.EligibilityActivity,
           eventType: CONSTANTS.STATISTICS.EligibilityCheck
         };
         const userStatsData = elgData.userService.getStatsticsInput(statsdata);
         elgData.eligibilityService.getEligibility(userData, userStatsData)
           .pipe(
             mergeMap((response: any) => {
               if (response) this.isOff = false;
               return of(response);
             }),
             catchError((error: any) => {
               return throwError(() => error);
             })
           ).subscribe();
       }, CONSTANTS.TIMEOUT.eligibilityError);
     });
   }
  ngOnInit(): void {
    // Add beforeunload event listener
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.startNotificationTimeCheck();
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      this.eventBus.emit(CONSTANTS.EVENTS.PAGE_LOADER, true);
      this.startUrl=event.url;

    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.checkForWildcardRoute();
      this.endUrl=event.url;
      const isEl = localStorage.getItem(CONSTANTS.STORAGE.userEligibility);
      if(this.endUrl=='/productline'){
        this.isProductLine=true;
      }else{
        this.isProductLine=false;
      }
      if(this.endUrl.indexOf('document')>0){
        let docId = sessionStorage.getItem(CONSTANTS.SessionSTORAGE.documentId);
        let soId = sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID);
        if(docId  && this.endUrl.indexOf('/document')==0 && (this.endUrl===this.startUrl) && localStorage.getItem(CONSTANTS.STORAGE.isdocumentEligible)=='false'){
          this.noFooter=true;
        }
        if (docId  && (isEl=='false' || isEl=='true') && this.endUrl.indexOf('/document')==0 && (this.endUrl===this.startUrl)) {
          this.setMetaData();
        }
        else if(!docId && !soId  && this.endUrl.indexOf('/document')==0 && (this.endUrl===this.startUrl)){
          this.isDocument='false';
          this.appLoaded = true;
          this.eventBus.emit('docsRlError','error');
          this.noFooter=true;
        }
        else{
          this.isDocument='false';
        }
      }
      if((this.endUrl===this.startUrl) && this.endUrl.indexOf('Shared%20Documents')<0 &&  this.endUrl.indexOf('document')<0){
        sessionStorage.removeItem(CONSTANTS.SessionSTORAGE.documentId);
        sessionStorage.removeItem(CONSTANTS.SessionSTORAGE.SOSessionID);
        sessionStorage.removeItem(CONSTANTS.SessionSTORAGE.startPage);
        this.isDocument='false';
      }
      let docId = sessionStorage.getItem(CONSTANTS.SessionSTORAGE.documentId);
      if (docId && isEl=='true' && this.endUrl=='/') {
        this.router.navigate(['/document']);
      if(window.self !== window.top){
        this.eventBus.emit(CONSTANTS.EVENTS.PAGE_NOT_FOUND,true);
      }
      }
      this.isUserEligible=localStorage.getItem(CONSTANTS.STORAGE.userEligibility)=='true'?true:false;
      setTimeout(() => {
      this.eventBus.emit(CONSTANTS.EVENTS.PAGE_LOADER, false);
    }, CONSTANTS.TIMEOUT.pageLoader);
    });
    this.networkStatusSubscription = this.networkService.isOnline$.subscribe(
      (isOnline) => {
        this.isOnline = isOnline;
        if(!this.isOnline && !this.isOff){
          this.isOff=true;
        }
        if(this.isOnline && this.isOff){
          this.isOff=false;
          let elgData=this;
          setTimeout(() => {
          const userData = this.getUserData();
          this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
          let statsdata={
            actionType: CONSTANTS.STATISTICS.EligibilityActivity,
            eventType:CONSTANTS.STATISTICS.EligibilityCheck
          }
          const userStatsData=elgData.userService.getStatsticsInput(statsdata,);
          elgData.elService.getEligibility(userData,userStatsData)
          .pipe(
            mergeMap((response: any) => {
              if(response){
                let isElig:any='false';
                if(response.getEligibilityRuleFromAPS.params['IsEligible']){
                  isElig='true';
                  elgData.getNotification();
                  setTimeout(() => {
                    location.reload()
                  },2000);
                }
                localStorage.setItem(CONSTANTS.STORAGE.userEligibility,isElig);
                this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
              }
              return of(response);
            }),
            catchError((error: any) => {
              this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
              return throwError(() => error);
            })
          ).subscribe();
          }, 1000);
        }
      }
    );
  }

  private getUserData(): any {
    return {
      "SO_Session_ID": sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID) || '',
      "User_ID": this.userService.getEmail(),
      "IP_Details": "",
      "Emp_ID": this.userService.getEmployeeCode(),
      "DaC_Session_ID": ""
    };
  }

   initializeEventBus(){
    this.eventBus.on(CONSTANTS.EVENTS.PAGE_LOADER, (data: any) => {
      this.productLineLoaded = data;
    }, true);

    this.eventBus.on(CONSTANTS.EVENTS.ACCESSDENIED, (data: any) => {
      this.isUserEligible = false;
      this.noFooter=true;
    }, true);
    this.eventBus.on('checknotification', (data: any) => {
      this.getNotification();
    }, true);

    this.eventBus.on('notificationRemoved', (id: any) => {
      this.onNotificationRemoved(id);
    }, true);
    this.appLoaded = false;
    this.eventBus.on(CONSTANTS.EVENTS.IS_ELIGIBLE, (data: any) => {
      this.isUserEligible=data=='true'?true:false;
      let docId = sessionStorage.getItem(CONSTANTS.SessionSTORAGE.documentId);
      if(data=='true' && docId){
      this.getMetaData();
      this.getMeta=true;
      }
      else if(data=='true' && !docId){
        this.isDocument='false';
        this.isfixedFooter=false;
        this.isUserEligible=true;
        setTimeout(() => {
          this.eventBus.emit('docsRlError','noerror');
        }, CONSTANTS.TIMEOUT.documentError);
      }
      else{
      this.isDocument='false';
      this.isfixedFooter=true;
      this.isUserEligible=false;
      setTimeout(() => {
        this.eventBus.emit('docsRlError','error');
      }, CONSTANTS.TIMEOUT.documentError);
      }
    }, true);
   }  


   getNotification(): void {
    // Call notification service for eligible users
    // Timer is automatically reset by the service on each call
     this.appServices.systemNotificationService.getUserDACNotifications().subscribe({
        next: (notificationResponse: any) => {
          console.log('Notifications received for eligible user:', notificationResponse);
          
          // Check if notifications exist and process active ones
          if (notificationResponse?.getUserDACNotifications?.length > 0) {
            const notifications = notificationResponse.getUserDACNotifications;
            
            // Find first active notification
            const activeNotification = notifications.find((notification: any) => notification.u_active === "true");
            
            if (activeNotification && activeNotification.u_message && activeNotification.u_message.trim() !== '') {
              this.eventBus.emit('showNotification', {
                'message': activeNotification.u_message,
                'sys_id': activeNotification.sys_id
              });
            }
          }
        },
        error: (notificationError: any) => {
          console.error('Error fetching notifications:', notificationError);
        }
      });
   }

   startNotificationTimeCheck(): void {
     // Check every minute if it's time to fetch notifications
     this.notificationCheckInterval = setInterval(() => {
       const nextCheckTime = localStorage.getItem(CONSTANTS.STORAGE.notificationNextCheckTime);
       const isEligible = localStorage.getItem(CONSTANTS.STORAGE.userEligibility);
       
       if (isEligible === 'true' && nextCheckTime) {
         const currentTime = Date.now();
         const checkTime = parseInt(nextCheckTime, 10);
         
         // If current time is greater than or equal to the stored check time
         if (currentTime >= checkTime) {
           this.getNotification();
         }
       }
     }, 60000); // Check every 1 minute
   }


   initializeEventMappings(): void {
      const eventMappings = [
        { event: 'appLoaded', property: 'appLoaded', additionalProperty: 'isDocument' },
        { event: 'showDocument', property: 'showDocumentBanner' },
        { event:'pageNotfound', property: 'pageNotfound' },
        { event: 'showterms', property: 'showTermsDialog' },
        { event:'isfixedFooter', property: 'isfixedFooter' },
        { event:'global-api-error-event',property:'apiError'},
        { event:'isapiError',property:'isapiError'},
        { event:'withoutFilter',property:'withoutFilter'},
      ];
      
      eventMappings.forEach(mapping => {
        const subscription = this.eventBus.on(mapping.event, (data: any) => {
          // Auth 401/403 are recovered via AuthInterceptor / SSO — do not show error popup
          if (mapping.event === 'global-api-error-event' && (data?.code === 401 || data?.code === 403)) {
            return;
          }
          this[mapping.property] = data;
          if (mapping.additionalProperty) {
            this[mapping.additionalProperty] = data;
          }
        }, true);
        this.eventSubscriptions.push(subscription);
      });
    }


    setMetaData(){
      this.appLoaded = false;
      let userData= {
        "SO_Session_ID": sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID)?sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID):'',
        "User_ID": this.userService.getEmail(),
        "IP_Details": "",
        "Emp_ID": this.userService.getEmployeeCode(),
        "DaC_Session_ID": ""

    }
    this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
    let statsdata={
      actionType: CONSTANTS.STATISTICS.EligibilityActivity,
      eventType:CONSTANTS.STATISTICS.DocumentEligibilityCheck
    }
    const userStatsData=this.userService.getStatsticsInput(statsdata);
    this.elService.getEligibility(userData,userStatsData)
    .pipe(
      mergeMap((response: any) => {
        let isElig:any='false';
        if(response?.getEligibilityRuleFromAPS?.params['IsEligible']){
            isElig='true';
          localStorage.setItem(CONSTANTS.STORAGE.userEligibility,isElig);
           this.getNotification();
           let statisticsdata={
            actionType:CONSTANTS.STATISTICS.GetDocumentMetaData,
            currentPageName:CONSTANTS.STATISTICS.DocumentPage,
            eventType:CONSTANTS.STATISTICS.RetrievingDocument,
          }
         const statsData=this.userService.getStatsticsInput(statisticsdata);
        return this.metaData.getDocumentMetaData(sessionStorage.getItem(CONSTANTS.SessionSTORAGE.documentId), sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID)?sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID):'',statsData)
        }
      }),
      catchError((error: any) => {
        // Handle the error for the first API call
        this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
        console.log('Catch Error');
        return throwError(() => error);
      })
    )
    .subscribe({
      next: (response: any) => {
        if(response['getDocumentMetaDataById'
        ]?.nonHtmlDocumentUrl){
          window.open(response['getDocumentMetaDataById'
          ].nonHtmlDocumentUrl,"_self")
        }
        else{
        this.isValidDocument=true;
        if (response && response['getDocumentMetaDataById'
      ]!=null && response['getDocumentMetaDataById'
      ]['fusionDoumentResponse']!=null && response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results'] !== null) {
          this.defTitle = response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields'];
          this.url = window.location.origin + response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields']?.['SPUrl']+'?ts='+ Date.now();
          this.docsUrl=this.url;
          let startPage = decodeURIComponent(sessionStorage.getItem(CONSTANTS.SessionSTORAGE.startPage));
          const expires = response?.['getDocumentMetaDataById']?.['expires'];
              if(expires){
                sessionStorage.setItem(CONSTANTS.SessionSTORAGE.documentExpiration,expires);
              }

          if(sessionStorage.getItem(CONSTANTS.SessionSTORAGE.startPage)){
              let directoryPath = response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields']?.['SPUrl']?.[0];
              let parts = directoryPath ? directoryPath.split('/'):'';
              let firstPart = parts.slice(0, 3).join('/');
              if(firstPart){
                this.url = window.location.origin +firstPart+'/'+startPage+'?ts='+ Date.now();
              }
          }
          this.isDocument = 'true';
          this.eventBus.emit('docsUrl',{'frameUrl':this.url,'documentUrl':this.docsUrl});
          if(window.self !== window.top){
            this.eventBus.emit(CONSTANTS.EVENTS.PAGE_NOT_FOUND,true);
            }

        }else{
          this.eventBus.emit(CONSTANTS.EVENTS.DOCUMENT_URL_ERROR,'error');
          this.appLoaded = true;
          this.isDocument = 'true';
          this.isValidDocument=false;
        }
       }
      },
      error: (error: any) => {
        this.eventBus.emit(CONSTANTS.EVENTS.IS_OFF_SUBSCRIPTION,true);
        console.error('Custom Error:', error);
        this.appLoaded = true;
      }
    });
    }

    closeError(){
      this.apiError='';
      this.isapiError=false;
    }

    getMetaData() {
    const DocUID =  sessionStorage.getItem(CONSTANTS.SessionSTORAGE.documentId)
    const SOSessionID= sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID)
    if(DocUID){
      this.docUId = DocUID
    }
    if(SOSessionID){
      this.sOSessionID =SOSessionID
    }
    else{
      this.sOSessionID = ' ';
    }

      this.appLoaded = false;
      this.metaData.getDocumentMetaData(this.docUId, this.sOSessionID)
        .pipe(
          mergeMap((response: any) => {
            if(response['getDocumentMetaDataById'
            ]?.nonHtmlDocumentUrl){
              window.open(response['getDocumentMetaDataById'
              ].nonHtmlDocumentUrl,"_self")
            }
            else{
              this.isValidDocument=true;
              if (response && response['getDocumentMetaDataById'
              ]!=null && response['getDocumentMetaDataById'
              ]['fusionDoumentResponse']!=null && response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results'] !== null) {
                  this.defTitle = response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields'];
                  this.url = window.location.origin + response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields']?.['SPUrl']+'?ts='+ Date.now();
                  this.docsUrl=this.url;
                  let startPage = decodeURIComponent(sessionStorage.getItem(CONSTANTS.SessionSTORAGE.startPage));
                  const expires = response?.['getDocumentMetaDataById']?.['expires'];
                      if(expires){
                        sessionStorage.setItem(CONSTANTS.SessionSTORAGE.documentExpiration,expires);
                      }

                    if(sessionStorage.getItem(CONSTANTS.SessionSTORAGE.startPage)){
                      let directoryPath = response?.['getDocumentMetaDataById']?.['fusionDoumentResponse']?.['results']?.['list']?.['docs']?.[0]?.['fields']?.['SPUrl']?.[0];
                      let parts = directoryPath.split('/');
                      let firstPart = parts.slice(0, 3).join('/');
                      if(firstPart){
                      this.url = window.location.origin +firstPart+'/'+startPage+'?ts='+ Date.now();
                    }
                  }
                this.isDocument = 'true';
                this.eventBus.emit('docsUrl',{'frameUrl':this.url,'documentUrl':this.docsUrl});
                if(window.self !== window.top){
                  this.eventBus.emit(CONSTANTS.EVENTS.PAGE_NOT_FOUND,true);
                }

              }else{
                this.eventBus.emit(CONSTANTS.EVENTS.DOCUMENT_URL_ERROR,'error');
                this.appLoaded = true;
                this.isDocument = 'true';
                this.isValidDocument=false;
              }
            }

            return of(response);
          }),
          catchError((error: any) => {
            return throwError(() => error);
          })
        ).subscribe();

    }

    checkForWildcardRoute(): void {
      let currentRoute = this.route.snapshot;
      currentRoute = currentRoute.firstChild;
      this.isWildcardRoute = !currentRoute.routeConfig || currentRoute.routeConfig.path === '**';
    }

 
    onNotificationRemoved(id: string): void {
      const input = {
        userDACNotificationInput: {
          sys_id: id,
          isRead: true
        }
      };

      this.setUserNotificationService.setUserNotification(input).subscribe({
        next: (response) => {
          console.log('Notification updated successfully:', response);
        },
        error: (error) => {
          console.error('Error updating notification:', error);
        }
      });
    }
    
    ngOnDestroy(): void {
      // Remove beforeunload event listener
      window.removeEventListener('beforeunload', this.handleBeforeUnload);

      // Remove event listener when component is destroyed
      this.eventSubscriptions.forEach(subscription => subscription.unsubscribe());
       // Clear notification check interval
      if (this.notificationCheckInterval) {
        clearInterval(this.notificationCheckInterval);
      }
    }
  private handleBeforeUnload = (event: BeforeUnloadEvent) => {
    // Log the event for debugging
    console.log('[AppComponent] beforeunload triggered');

    // Trigger the browser's default confirmation dialog
    //event.preventDefault();
    event.returnValue = '';

    // Prepare statistics data
    const statsData = {
      actionType: CONSTANTS.STATISTICS.ActionType,
      eventType: CONSTANTS.STATISTICS.BrowserClose,
      currentPage: this.userService.getCurrentPage() || '',
      previousPage: this.userService.getPreviousPage() || ''
    };

    // Use navigator.sendBeacon for reliability
    const data=this.userService.getStatsticsInput(statsData);
   // const url = this.userService.saveUserActivity(data);

  };


  }
